// src/contexts/SocketContext.js
import React, { createContext, useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  socket,
  connectSocket,
  disconnectSocket,
  joinRoom,
} from "../services/socket";

const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    // Connect when the provider mounts
    connectSocket();

    // Handle connection events
    socket.on("connect", () => {
      // Join user room for personalized events
      if (user?.id) {
        joinRoom(user.id);
      }
    });

    socket.on("disconnect", (reason) => {});

    return () => {
      // Clean up listeners and disconnect when unmounting
      socket.off("connect");
      socket.off("disconnect");
      disconnectSocket();
    };
  }, [user?.id]);

  // Also join room when user changes (login)
  useEffect(() => {
    if (socket.connected && user?.id) {
      joinRoom(user.id);
    }
  }, [user?.id]);

  return (
    <SocketContext.Provider value={{ socket }}>
      {children}
    </SocketContext.Provider>
  );
};

// Hook to use socket in any component
export const useSocket = () => useContext(SocketContext);
